import { urls } from 'config';
import { fetchData } from './net';
import { getHeaders } from './headers';

// eslint-disable-next-line
export const getStops = async () => {
  try {
    const response = await fetchData(urls.stops, { headers: getHeaders() });

    if (!response.ok) {
      throw new Error(response.status);
    }

    const responseJSON = await response.json();

    return responseJSON;
  } catch (error) {
    throw error;
  }
};
